import React from 'react'


function FixtureTabs({ toggle, activeItem }) {
    return (
        <div className="row d-flex justify-content-between mb-1 bg-white" style={{ borderTop: "1px solid #e3e3e3" }}>
            <div style={{ width: "25%" }}>
                <button
                    style={{ backgroundColor: "transparent", border: "none" }}
                    onClick={() => toggle("1")}
                    className={activeItem === "1" ? "btn-block text-dark p-2 z-depth-1" : "btn-block grey-text p-2"}
                >
                    Lineups
                </button>
            </div>
            <div style={{ width: "25%" }}>
                <button
                    style={{ backgroundColor: "transparent", border: "none" }}
                    onClick={() => toggle("2")}
                    className={activeItem === "2" ? "btn-block text-dark p-2 z-depth-1" : "btn-block grey-text p-2"}
                >
                    Stats
                </button>
            </div>
            <div style={{ width: "25%" }}>
                <button
                    style={{ backgroundColor: "transparent", border: "none" }}
                    onClick={() => toggle("3")}
                    className={activeItem === "3" ? "btn-block text-dark p-2 z-depth-1" : "btn-block grey-text p-2"}
                >
                    Events
                </button>
            </div>
            <div style={{ width: "25%" }}>
                <button
                    style={{ backgroundColor: "transparent", border: "none" }}
                    onClick={() => toggle("4")}
                    className={activeItem === "4" ? "btn-block text-dark p-2 z-depth-1" : "btn-block grey-text p-2"}
                >
                    Table
                </button>
            </div>
        </div>
    )
}
export default FixtureTabs